import { Heading, Paragraph } from "@digdir/designsystemet-react";

export const BeregneMvaSection = () => {
  return (
    <section className="space-y-3">
      <Paragraph>
        Stønadsbeløpet for strømstøtteordningen, og prissikringsbeløpet for
        Norgespris, er inklusive merverdiavgift (mva). Merverdiavgiften beregnes
        på basisfaktura for fjernvarme, ikke på justeringen for Norgespris eller
        strømstøtteordningen. Det betyr:
        <ol>
          <li>Beregn basisfaktura for fjernvarme inkludert merverdiavgift.</li>
          <li>
            Legg til justering for Norgespris eller Strømstøtteordningen (som
            inkluderer mva).
          </li>
          <li>*Mva skal ikke legges til justering på nytt.</li>
        </ol>
      </Paragraph>
      <div className="border border-balder-border-subtle rounded-lg p-6">
        <Heading level={3} data-size="xs" className="mb-2">
          Eksempel på fjernvarmeregning med Norgespris
        </Heading>
        <Paragraph className="text-sm mb-4">
          Faktura til en bolig i NO2 som har valgt Norgespris.
        </Paragraph>
        <Paragraph className="text-sm mb-4">
          Gitt gjennomsnittlig spotpris i NO2 for Januar på 0,8770 kr/kWh (ink.
          Mva). Referansepris Norgespris på 0,50 kr/kWh (ink. Mva).
          Prissikringsverdien blir da 0,50 - 0,8770 = -0,3770.
        </Paragraph>
        <table className="w-full border-collapse text-sm">
          <thead>
            <tr>
              <th className="border border-balder-border-strong p-2 text-left font-semibold">
                &nbsp;
              </th>
              <th className="border border-balder-border-strong p-2 text-right font-semibold">
                Antall kWh
              </th>
              <th className="border border-balder-border-strong p-2 text-right font-semibold">
                Pris per kWh
              </th>
              <th className="border border-balder-border-strong p-2 text-right font-semibold">
                Beløp
              </th>
              <th className="border border-balder-border-strong p-2 text-right font-semibold">
                Mva
              </th>
              <th className="border border-balder-border-strong p-2 text-right font-semibold">
                Sum
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="border border-balder-border-strong p-2 font-semibold">
                Kjøpt fjernvarme
              </td>
              <td className="border border-balder-border-strong p-2 text-right">
                4500
              </td>
              <td className="border border-balder-border-strong p-2 text-right">
                1,50
              </td>
              <td className="border border-balder-border-strong p-2 text-right">
                6 750,00
              </td>
              <td className="border border-balder-border-strong p-2 text-right">
                1 687,50
              </td>
              <td className="border border-balder-border-strong p-2 text-right font-semibold">
                8 437,50
              </td>
            </tr>
            <tr>
              <td className="border border-balder-border-strong p-2 font-semibold">
                Norgespris
              </td>
              <td className="border border-balder-border-strong p-2 text-right">
                4500
              </td>
              <td className="border border-balder-border-strong p-2 text-right">
                - 0,3770
              </td>
              <td className="border border-balder-border-strong p-2 text-right">
                - 1 696,50
              </td>
              <td className="border border-balder-border-strong p-2 text-right">
                &nbsp;
              </td>
              <td className="border border-balder-border-strong p-2 text-right">
                - 1 696,50
              </td>
            </tr>
            <tr>
              <td className="border border-balder-border-strong p-2 font-semibold">
                Sum å betale
              </td>
              <td className="border border-balder-border-strong p-2 text-right">
                &nbsp;
              </td>
              <td className="border border-balder-border-strong p-2 text-right">
                &nbsp;
              </td>
              <td className="border border-balder-border-strong p-2 text-right">
                &nbsp;
              </td>
              <td className="border border-balder-border-strong p-2 text-right">
                &nbsp;
              </td>
              <td className="border border-balder-border-strong p-2 text-right font-semibold">
                6 741,00
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>
  );
};
